var map = {
	"./add.svg": "58n+",
	"./add_admin.svg": "8Z1m",
	"./black.svg": "iJJr",
	"./cancel.svg": "pdRo",
	"./comment.svg": "SdtW",
	"./del.svg": "CWZL",
	"./delete_img.svg": "fDI7",
	"./detail.svg": "rSG0",
	"./edit.svg": "ql+d",
	"./finance.svg": "pTuU",
	"./home.svg": "U9Ws",
	"./move.svg": "f6CS",
	"./order.svg": "gYtG",
	"./physical.svg": "GseJ",
	"./remove.svg": "VFDz",
	"./rent.svg": "GMBf",
	"./reset.svg": "kaIC",
	"./right.svg": "9iyg",
	"./search.svg": "Bx0U",
	"./shop.svg": "hert",
	"./ums.svg": "J4x9",
	"./upload.svg": "P/TB",
	"./user.svg": "VdD3",
	"./white.svg": "OMai"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "90Fk";


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg nonrecursive \.svg$
// module id = 90Fk
// module chunks = 27